import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { fontConvertor } from 'preeti-unicode';

@Component({
  selector: 'app-nepali-input',
  templateUrl: './nepali-input.component.html',
  styleUrl: './nepali-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NepaliInputComponent),
      multi: true,
    },
  ],
  standalone: true
})
export class NepaliInputComponent implements ControlValueAccessor {
  @Input() label!: string;
  @Input() placeholder = '';
  @Input() readonly = false;
  @Input() calculated = false;
  @Input() required = false;
  @Input() inputId!: string;

  @Output() valueChange = new EventEmitter<string>();

  value: string = '';
  floatingSuggestion = '';
  isFocused = false;

  fontConverter = new fontConvertor();

  @ViewChild('floatingSuggestionRef') floatingSuggestionRef!: ElementRef;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor() {}

  writeValue(value: any): void {
    this.value = value || '';
    this.updateSuggestion();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.readonly = isDisabled;
  }

  onFocus() {
    this.isFocused = true;
    this.updateSuggestion();
  }

  onInput(value: string) {
    this.value = value;
    this.onChange(value);
    this.valueChange.emit(value);
    this.updateSuggestion();
  }

  patchValue() {
    this.value = this.floatingSuggestion;
    this.onChange(this.value);
    this.onTouched();
    this.valueChange.emit(this.value);
  }

  private updateSuggestion() {
    this.floatingSuggestion =
      this.fontConverter.convertToUnicode(this.value) || this.value;
  }

}
